import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Button, Card, CardBody, Col, Container, Input,
  Modal, ModalBody, ModalFooter, ModalHeader, Row, Table, UncontrolledTooltip
} from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
import {
  useMenuFindAllQuery,
  useMenuPermissionFindAllQuery,
  useMenuRoleCreateMutation,
  useMenuRoleDeleteMutation,
  useMenuRolePermissionReplaceMutation,
  useMenuRoleFindAllQuery,
  useRoleFindAllQuery,
  useMenuRolePermissionFindAllQuery
} from "store";
import Language from '../../../../locales/mn/translation.json';
import menuRoleSvg from '../../../../assets/images/svg/menuRole.svg';
import { numberWithCommas } from "../../../../helpers/globalHelper";
import DeleteModal from "Components/Common/DeleteModal";

const SettingsMenuRole = () => {
  const { id } = useParams();
  const [menuList, setMenuList] = useState<any[]>([]);
  const [menuRoleList, setMenuRoleList] = useState<any[]>([]);
  const [myMenuRoleList, setMyMenuRoleList] = useState<any[]>([]);
  const [currentRoleData, setCurrentRoleDataList] = useState<any>();
  const [menuCount, setMenuCount] = useState<number>(0);
  const [selectedPermissions, setSelectedPermissions] = useState<number[]>([]);
  const [menuOne, setMenuOne] = useState<any>(null);

  const [createModal, setCreateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [permissionModal, setPermissionModal] = useState(false);

  const [selectedType, setSelectedType] = useState("");

  const [menuRoleCreate] = useMenuRoleCreateMutation();
  const [menuRoleDelete] = useMenuRoleDeleteMutation();
  const [replacePermission] = useMenuRolePermissionReplaceMutation();

  const { data: menuData } = useMenuFindAllQuery();
  const { data: menuRoleData } = useMenuRoleFindAllQuery();
  const { data: myMenuRoleData } = useMenuRoleFindAllQuery(`?role_id=${id}`);
  const { data: currentRole } = useRoleFindAllQuery(`?id=${id}`);
  const { data: permissionData } = useMenuPermissionFindAllQuery(permissionModal && menuOne?.menu_id ? `?menu_id=${menuOne?.menu_id}` : undefined);
  const { data: rolePermissionData } = useMenuRolePermissionFindAllQuery(
    permissionModal && menuOne?.menu_id ? `?role_id=${id}&menu_id=${menuOne.menu_id}` : undefined
  );

  useEffect(() => {
    setMenuList(menuData?.data || []);
    setMenuRoleList(menuRoleData?.data || []);
    setMyMenuRoleList(myMenuRoleData?.data || []);
    setCurrentRoleDataList(currentRole?.data?.[0]);
    setMenuCount(myMenuRoleData?.data?.length || 0);
  }, [menuData, menuRoleData, myMenuRoleData, currentRole]);

  useEffect(() => {
    if (permissionModal && rolePermissionData?.data) {
      const existingPermissions = rolePermissionData.data.map(p => p.menu_permission_id);
      setSelectedPermissions(existingPermissions);
    }
  }, [permissionModal, rolePermissionData]);

  const toggleCreateModal = useCallback(() => {
    if (createModal) {
      setMenuOne(null);
      setCreateModal(false);
    } else setCreateModal(true);
  }, [createModal]);

  const togglePermissionModal = useCallback(() => {
    if (permissionModal) {
      setPermissionModal(false);
      setMenuOne(null);
      setSelectedPermissions([]);
    } else setPermissionModal(true);
  }, [permissionModal]);

  const menuPermissionHandle = (menu) => {
    setMenuOne({ menu_id: menu.menu_id });
    setPermissionModal(true);
  };

  const deleteData = (menu, roleMenuId) => {
    setMenuOne({ id: roleMenuId, name: menu.name });
    setDeleteModal(true);
  };

  const handleDeleteJob = () => {
    if (menuOne) {
      menuRoleDelete(menuOne.id);
      setDeleteModal(false);
    }
  };

  const handleChange = (e) => setSelectedType(e.target.value);

  const menuRoleInsert = () => {
    if (!selectedType) return;
    menuRoleCreate({ menu_id: selectedType, role_id: id });
    setSelectedType("");
    toggleCreateModal();
  };

  return (
    <>
      <DeleteModal
        deleteName={menuOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeleteJob}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Системийн удирдлага"
            breadcrumbItem={`${currentRoleData?.description} Меню хандах эрх`}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <img src={menuRoleSvg} alt="" height="50" />
                    <div className="flex-grow-1 ms-3">
                      <h5 className="fw-semibold">Мэдээлэл</h5>
                      <ul className="list-unstyled hstack gap-2 mb-0">
                        <li>
                          <i className="mdi mdi-table-row-height"></i>{" "}
                          <span className="text-muted fw-semibold">
                            Нийт: {numberWithCommas(menuCount)}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <button
                      type="button"
                      onClick={toggleCreateModal}
                      className="btn btn-success btn-label"
                    >
                      <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                    </button>
                  </div>
                </CardBody>

                <CardBody>
                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Парент код</th>
                          <th>Код</th>
                          <th>Нэр</th>
                          <th>Меню Url</th>
                          <th>Меню Icon</th>
                          <th>Парент Id</th>
                          <th>Үйлдэл</th>
                        </tr>
                      </thead>
                      <tbody>
                        {menuList.map((menu) =>
                          myMenuRoleList
                            .filter((roleMenu) => menu.menu_id === roleMenu.menu_id)
                            .map((roleMenu) => (
                              <tr key={roleMenu.menu_id}>
                                <th scope="row">{menu.menu_id}</th>
                                <td>{menu.parent_code}</td>
                                <td>{menu.code}</td>
                                <td>{Language[menu.name]}</td>
                                <td>{menu.menu_url}</td>
                                <td>{menu.menu_icon}</td>
                                <td>{menu.parent_id}</td>
                                <td>
                                  <ul className="list-unstyled hstack gap-1 mb-0">
                                    <li>
                                      <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-danger"
                                        onClick={() =>
                                          deleteData(menu, roleMenu.menu_role_id)
                                        }
                                      >
                                        <i className="mdi mdi-delete-outline" />
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-primary"
                                        onClick={() => menuPermissionHandle(menu)}
                                      >
                                        <i className="mdi mdi-folder-key-outline" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={createModal}
        toggle={toggleCreateModal}
        backdrop="static"
        centered
      >
        <ModalHeader toggle={toggleCreateModal}>Хандах эрх Меню нэмэх</ModalHeader>
        <ModalBody>
          <Input
            type="select"
            value={selectedType}
            onChange={handleChange}
          >
            <option disabled value="">Сонго</option>
            {menuList
              .filter(item => !myMenuRoleList.some(myMenu => item.menu_id === myMenu.menu_id))
              .map((item) => (
                <option key={item.menu_id} value={item.menu_id}>
                  {Language[item.name]}
                </option>
              ))}
          </Input>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={menuRoleInsert}>Хадгалах</Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={permissionModal}
        toggle={togglePermissionModal}
        size="lg"
        backdrop="static"
        centered
      >
        <ModalHeader toggle={togglePermissionModal}>Меню зөвшөөрөл</ModalHeader>
        <ModalBody>
          <Table className="table mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Меню код</th>
                <th>Код</th>
                <th>Нэр</th>
                <th>Display</th>
                <th>Тайлбар</th>
                <th>Сонгох</th>
              </tr>
            </thead>
            <tbody>
              {permissionData?.data?.map((item, index) => (
                <tr key={item.permission_id}>
                  <th scope="row">{index + 1}</th>
                  <td>{item.menu_code}</td>
                  <td>{item.code}</td>
                  <td>{item.name}</td>
                  <td>{item.display}</td>
                  <td>{item.description}</td>
                  <td>
                    <Input
                      type="checkbox"
                      checked={selectedPermissions.includes(item.permission_id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedPermissions([...selectedPermissions, item.permission_id]);
                        } else {
                          setSelectedPermissions(
                            selectedPermissions.filter(id => id !== item.permission_id)
                          );
                        }
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={async () => {
              if (!menuOne?.menu_id) return;
              await replacePermission({
                role_id: id as string,
                menu_id: menuOne.menu_id,
                permissionIds: selectedPermissions
              });
              setSelectedPermissions([]);
              setPermissionModal(false);
            }}
          >
            Хадгалах
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SettingsMenuRole;
